import { gqlClient } from '@/api/graphql-client';
import applianceKeys from '@/api/queries/appliances/keyFactory';
import productSpecKeys from '@/api/queries/productSpecs/keyFactory';
import { graphql } from '@/gql';
import {
  UpdateApplianceInput,
  UpdateApplianceMutation as UpdateApplianceMutationResult,
} from '@/gql/graphql';
import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

const UpdateApplianceMutation = graphql(`
  mutation UpdateAppliance($input: UpdateApplianceInput!) {
    updateAppliance(input: $input) {
      id
      isPreferred
    }
  }
`);

const useUpdateAppliance = (
  options?: UseMutationOptions<
    UpdateApplianceMutationResult,
    Error,
    UpdateApplianceInput
  >
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input) =>
      gqlClient.request(UpdateApplianceMutation, { input }),
    onSettled: () => {
      void queryClient.invalidateQueries({ queryKey: applianceKeys.all });
      // The spec search exposes each spec's Appliance, so refresh it too.
      void queryClient.invalidateQueries({ queryKey: productSpecKeys.all });
    },
    ...options,
  });
};

export default useUpdateAppliance;
